const ACCESS_ROLE_ID = 'access_role_id';
const ACCESS_ROLE_RESOURCE = 'access_role_resource';
const APP_PAIR = 'app_pair';
const BRANCH_ACCOUNT_ID = 'branch_account_id';
const BRANCH_ACCOUNT_OWNER = 'branch_account_owner';
const BRANCH_ACCOUNT_USER_ACCESS = 'branch_account_user_access';
const CREATED_ON = 'app_created_on';
const DASHBOARD_USER = 'dashboard_user';
const DASHBOARD_USER_ID = 'dashboard_user_id';
const LIVE_ID = 'live_id';
const ORGANIZATION = 'organization';
const TEST_ID = 'test_id';
const USER_APP_ACCESS = 'user_app_access';

/**
 * Allowable values for Branch Account Service "extend" parameters.
 */
export const EXTENSIONS = {
  ACCESS_ROLE: {
    ACCESS_ROLE_RESOURCE,
  },
  APP: {
    CREATED_ON,
  },
  APP_PAIR: {
    BRANCH_ACCOUNT_ID,
    LIVE_ID,
    TEST_ID,
  },
  BRANCH_ACCOUNT: {
    APP_PAIR,
    BRANCH_ACCOUNT_OWNER,
    DASHBOARD_USER,
    ORGANIZATION,
  },
  BRANCH_ACCOUNT_OWNER: {
    BRANCH_ACCOUNT_ID,
    DASHBOARD_USER_ID,
  },
  BRANCH_ACCOUNT_USER_ACCESS: {
    BRANCH_ACCOUNT_ID,
    DASHBOARD_USER_ID,
    ACCESS_ROLE_ID,
  },
  DASHBOARD_USER: {
    BRANCH_ACCOUNT_ID,
    BRANCH_ACCOUNT_OWNER,
    USER_APP_ACCESS,
    BRANCH_ACCOUNT_USER_ACCESS,
  },
  ORGANIZATION: {
    BRANCH_ACCOUNT_ID,
  },
};
